/**
 * Sweet little script for loading the component files automagically
 */

// Define contexts to require
const contexts = [require.context("./", true, /\.vue$/)];

// Define components
const components = [];
contexts.forEach((context) => {
	context.keys().forEach((key) => components.push(context(key).default));
});
// Install the above defined components
const Components = {
	install(Vue) {
		components.forEach((component) => {
			Vue.component(component.name, component);
		});
	}
};

// Finally export as default
export default Components;
